if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event && event.cartData && this.currentVariant && this.currentVariant.value) {
            this.updateCartQuantityFromCartData(event.cartData);
          } else {
            this.refreshCartQuantityFromServer();
          }
        });
        this.observeCartBubble();
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
      if (this.cartBubbleObserver) {
        this.cartBubbleObserver.disconnect();
      }
    }

    observeCartBubble() {
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      this.cartBubbleObserver = new MutationObserver(() => {
        this.refreshCartQuantityFromServer();
      });
      this.cartBubbleObserver.observe(bubble, { childList: true, subtree: true, characterData: true });
    }

    refreshCartQuantityFromServer() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
        .then((r) => r.json())
        .then((cartData) => this.updateCartQuantityFromCartData(cartData))
        .catch(() => {});
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);  
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateCartQuantityFromCartData(cartData) {
      if (!this.currentVariant || !this.currentVariant.value) return;
      const variantId = parseInt(this.currentVariant.value, 10);
      const items = (cartData && cartData.items) || [];
      const cartQty = items
        .filter((item) => item.variant_id === variantId)
        .reduce((sum, item) => sum + item.quantity, 0);

      this.input.setAttribute('data-cart-quantity', cartQty);

      const rulesCart = this.quantityForm.querySelector('.quantity__rules-cart');
      if (rulesCart) {
        rulesCart.classList.toggle('hidden', cartQty === 0);
        const qtySpan = rulesCart.querySelector('.quantity-cart');
        if (qtySpan) qtySpan.textContent = cartQty;
      }

      this.setQuantityBoundries();
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }
  }
)};



